// removed by extract-text-webpack-plugin
module.exports = {"edit-link":"_2RL_gf_sEucZGWHUqkGxU0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/EditIcon.mod.css
// module id = 2122
// module chunks = 0